import styled from 'styled-components';

const size = 12;
const outlineSize = size / 4;

export const Container = styled.div`
  margin: 0 auto;
   position: relative;
  text-indent: -9999em;
  border-top: ${outlineSize}px solid #EBF2F4;
  border-right: ${outlineSize}px solid #EBF2F4;
  border-bottom: ${outlineSize}px solid #EBF2F4;
  border-left: ${outlineSize}px solid #35748A;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;

  border-radius: 50%;
  width: ${size}px;
  height: ${size}px;

  &:after {
    border-radius: 50%;
    width: ${size}px;
    height: ${size}px;

  }

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
`;
